<div class="toolbar"><ng-content></ng-content></div>
<div class="infoBox">
  <itl-info-box *ngIf="showInfoBox" [type]="infoBoxType" [baseColor]="infoBoxBaseColor">{{ infoBoxText }}</itl-info-box>
</div>
